module.exports = __webpack_public_path__ + "public/img/故障.0044ff76.png";